import { createContext, useState, ReactNode, useEffect } from 'react';

export type UserContectProviderProps = {
  children: ReactNode;
};

export type UserInfoType = {
  id?: string;
  role?: string;
  email?: string;
};

export type UserContextType = {
  userInfo: UserInfoType | null;
  setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType | null>>;
};

export const UserContext = createContext<UserContextType>({
  userInfo: null,
  setUserInfo: () => {},
});

export const UserContextProvider = ({ children }: UserContectProviderProps) => {
  const [userInfo, setUserInfo] = useState<UserInfoType | null>(null);

  useEffect(() => {
    // ověří, zda je uživatel přihlášený
    fetch(`${process.env.REACT_APP_BACKEND_URL}/profile`, {
      credentials: 'include',
    })
      .then((res) => {
        if (!res.ok) throw new Error('Not logged in');
        return res.json();
      })
      .then((user) => setUserInfo(user))
      .catch(() => setUserInfo(null)); // pokud není platný token
  }, []);

  return <UserContext.Provider value={{ userInfo, setUserInfo }}>{children}</UserContext.Provider>;
};
